/**
 * @name isValidPassword
 * @public
 * @description Validates if a string meets the password requirements.
 * A valid password must:
 * - Be at least 8 characters long
 * - Contain at least one letter (A-Z or a-z)
 * - Contain at least one digit (0-9)
 * @param {string} password - The password string to validate
 * @returns {boolean} Returns true if the password meets requirements, false otherwise
 */
export default function isValidPassword(password) {
  const re = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
  return re.test(String(password));
}
